import { EntityService } from "../../service/EntityService";

export class DashboardService extends EntityService {
  static entity = 'api/app/dashboard';

  static getOrderInfo(params): Promise<any> {
    return this.axios.get(`${this.entity}/order-info?${params}`).then((res) => res.data);
  }

  static getSaleInfo(params): Promise<any> {
    return this.axios.get(`${this.entity}/sales-info?${params}`).then((res) => res.data);
  }

  static getLicenseInfo(): Promise<any> {
    return this.axios.get(`${this.entity}/license-info`).then((res) => res.data);
  }

  static getDashboard(params): Promise<any> {
    return this.axios.get(`${this.entity}/order-statistic?${params}`).then((res) => res.data);
  }
}
